module.exports = __webpack_public_path__ + "media/images/xpass/brand_previews/clubpilates-59021443c904b4061a0ed3c0f0550fec.jpg";